export const PRO_PAGES = {
  COMPANIES: 'companies',
  AGENCIES: 'agencies',
  ARTISTS: 'artists',
  ACADEMIA: 'academia',
  JOURNALIST: 'journalist',
  CASTING_TOOL: 'casting',
};
